export default __webpack_public_path__ + "static/media/Gerald&Eric2400.96670701.jpg";